export const GET_LABOR = 'GET_LABOR';
export const GET_LABOR_SUCCESS = 'GET_LABOR_SUCCESS';
export const CREATE_LABOR = 'CREATE_LABOR';
export const CREATE_LABOR_SUCCESS = 'CREATE_LABOR_SUCCESS';
export const UPDATE_LABOR = 'UPDATE_LABOR';
export const UPDATE_LABOR_SUCCESS = 'UPDATE_LABOR_SUCCESS';
export const DELETE_LABOR = 'DELETE_LABOR';
export const DELETE_LABOR_SUCCESS = 'DELETE_LABOR_SUCCESS';
export const GET_BULK_LABOR = 'GET_BULK_LABOR';
export const GET_BULK_LABOR_SUCCESS = 'GET_BULK_LABOR_SUCCESS';
export const REORDER_LABOR = 'REORDER_LABOR';
export const REORDER_LABOR_SUCCESS = 'REORDER_LABOR_SUCCESS';
